export const VAT_RATE = 0.25;

// Plan hierarchy — higher tier includes all features of lower tiers.
// Trial users are treated as "starter".
export const PLAN_TIER: Record<string, number> = {
  starter: 1,
  pro: 2,
  agency: 3,
  chef: 4,
};

// Monthly AI credit allowance per plan.
export const PLAN_CREDITS: Record<string, number> = {
  starter: 100,
  pro: 500,
  agency: 2000,
  chef: 5000,
};

// "Zensio Chef" säljs via kontakt tills betalflödet är uppsatt i Stripe.
export const CHEF_PLAN = {
  name: "Zensio Chef",
  price: 2490,
  priceInclVat: 3113,
  currency: "kr/mån",
  description: "AI-chefen som håller koll på hela företaget",
  features: [
    "Allt i Pro, plus:",
    "Business Brain: all företagsdata samlad och normaliserad",
    "AI-chefen: dagliga beslut, måluppföljning och måländringar",
    "Godkännandekö för allt AI:n förbereder",
    "Alla integrationer: Fortnox, Gmail/Outlook, Kalender, Search Console",
    "5 000 AI-krediter/mån",
  ],
} as const;

export function planMeetsMinimum(plan: string | null | undefined, minPlan: string): boolean {
  if (!plan) return false;
  return (PLAN_TIER[plan] ?? 0) >= (PLAN_TIER[minPlan] ?? 0);
}

export const STRIPE_PLANS = {
  starter: {
    name: "Starter",
    price_id: "price_1T6sWpEIRb6OmPi7ME4XeYU8",
    product_id: "prod_U52ctEK38NZXhU",
    price: 499,
    priceInclVat: 624,
    currency: "kr/mån",
    description: "För enskild företagare som vill komma igång",
    features: [
      "Sociala medier: 30 AI-inlägg/mån, 2 kanaler",
      "Marknadsföring: 1 nyhetsbrev/mån",
      "Kundservice: publik supportwidget",
      "Analys: grundläggande rapporter",
      "100 AI-krediter/mån",
    ],
  },
  pro: {
    name: "Pro",
    price_id: "price_1TrZNMEIRb6OmPi739GGJ9Je",
    product_id: "prod_UrHxeZMh8XbFPD",
    price: 1299,
    priceInclVat: 1624,
    currency: "kr/mån",
    description: "Hela företaget på autopilot",
    features: [
      "Allt i Starter, plus:",
      "Obegränsade AI-inlägg, alla 5 kanaler",
      "Försäljning: CRM, offerter & lead-kvalificering",
      "Marknadsföring: kampanjer + obegränsade nyhetsbrev",
      "Kundservice: AI-inbox & FAQ-bot",
      "Företagets minne (RAG) + Fortnox-integration",
      "Autonom AI-agent + morgonbrief",
      "500 AI-krediter/mån",
    ],
    highlight: true,
  },
  agency: {
    name: "Byrå",
    price_id: "price_1T6sXLEIRb6OmPi7OECW54g0",
    product_id: "prod_U52cexQCIXCZxb",
    price: 2499,
    priceInclVat: 3124,
    currency: "kr/mån",
    description: "För byrån som hanterar flera kunder",
    features: [
      "Allt i Pro för upp till 10 kunder",
      "Godkännandeflöden & team-roller",
      "White-label rapporter",
      "2 000 AI-krediter/mån (delat)",
      "Prioriterad support + onboarding",
    ],
  },
} as const;

export type PlanKey = keyof typeof STRIPE_PLANS;

export function getPlanByProductId(productId: string): PlanKey | null {
  for (const [key, plan] of Object.entries(STRIPE_PLANS)) {
    if (plan.product_id === productId) return key as PlanKey;
  }
  return null;
}
